import React from 'react'
import { BsArrowRightShort } from 'react-icons/bs'
import './HomeContent.scss'

interface Props {
  cursor: any
  cursorText: any
}

function HomeContent({ cursor, cursorText }: Props) {
  const onMouseEnter = (e: React.MouseEvent) => {
    cursor.current.style.height = '9rem'
    cursor.current.style.width = '9rem'
    cursorText.current.style.opacity = 1
  }

  const onMouseLeave = (e: React.MouseEvent) => {
    cursor.current.style.height = '2rem'
    cursor.current.style.width = '2rem'
    cursorText.current.style.opacity = 0
  }

  return (
    <div className='homeContent'>
      <h1>Software Engineer</h1>
      <h2>William Simms</h2>

      <div className='home__content__follow'>
        <h3>Follow me</h3>
        <a
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          href='https://github.com/williamsimms'
          className='home__content__follow__icon__container'
          target='_blank'
          rel='noopener noreferrer'>
          <BsArrowRightShort className='home__content__follow__icon' />
        </a>
      </div>
    </div>
  )
}

export default HomeContent
